<template>
  <v-dialog
    v-model="isOpen"
    max-width="790"
    width="530"
    persistent
    @keydown.prevent.enter="split"
  >
    <v-card class="dialog-box">
      <v-layout row justify-space-between class="home-floating-window-header">
        <v-layout row justify-start align-center>
          <v-card-title class="headline">
            {{ $t("SplitSelectedPathway.title") }}
          </v-card-title>
        </v-layout>
        <window-header-button @onClick="cancel" mode="dark" />
      </v-layout>
      <v-card-text>
        {{ $t("SplitSelectedPathway.initialMessage") }}
        - {{ $t("SplitSelectedPathway.splitMessage") }}
        {{
          !onFirstPoint
            ? " (" + $t("SplitSelectedPathway.warningMessage") + ")"
            : null
        }}
        - {{ $t("SplitSelectedPathway.snapMessage") }}
        {{
          !onFirstPoint
            ? " (" + $t("SplitSelectedPathway.warningMessage") + ")"
            : null
        }}
      </v-card-text>

      <v-card-actions>
        <v-btn @click="snap" :ripple="false" class="main-button" text>
          {{ $t("Snap") }}
        </v-btn>

        <v-btn @click="split" :ripple="false" class="main-button" text>
          {{ $t("Split") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import WindowHeaderButton from "@/components/_Atoms/WindowHeaderButton";
export default {
  name: "PathwaySplitPathwayDialog",
  components: { WindowHeaderButton },
  props: {
    open: {
      type: Boolean,
      required: true
    },

    onFirstPoint: {
      type: Boolean
    }
  },

  data() {
    return {
      isOpen: false
    };
  },

  methods: {
    /**
     * Send an event to the parent to execute the main action.
     */
    cancel() {
      this.$emit("cancel");
    },
    /**
     * Send an event to the parent to execute the main action.
     */
    snap() {
      this.$emit("snap");
    },
    /**
     * Send an event to the parent to execute the secondary action.
     */
    split() {
      this.$emit("split");
    }
  },

  watch: {
    open(newValue) {
      this.isOpen = newValue;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Dialog/DialogPathwaySplitPathway.vue